import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';

export interface FilterBlockProps {
    title: string;
    children: JSX.Element;
}

interface StyledFilterBlockProps extends JSSClassesProps<ComponentJSSClasses>, FilterBlockProps {}

export const FilterBlock = (props: StyledFilterBlockProps) => {
    const { classes, title } = props;

    return (
        <div className={classes.container}>
            <h3 className={classes.title}>{title}</h3>
            {props.children}
        </div>
    );
};
